export default function formatMessageContentTable ({
    answer,
    tuples
}) {
    return {
        text: answer,
        table: tuples
    }
}
